<template>

    <v-card >
      <v-container >



        <v-card-title  >Отчёт продажа товаров
            <v-divider class="mx-4" inset vertical></v-divider>
            <export-json-excel
                    :data="filteredDesserts"
                    :fields="export_furush_fields"
                    :worksheet="'' + date1 + ' - ' + date2"
                    :name="'Продажа товаров ' + date1 + ' - ' + date2 ">
                      <v-icon  color="success" >
                        mdi-microsoft-excel
                        </v-icon>
                  </export-json-excel>

        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">
              <v-menu class="m-2"
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date1"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date1"
                  label="Дата 1"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date1"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_furushho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>




            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Категория"
            hide-details
            multiple
            solo
            prepend-icon="mdi-filter-menu-outline"
            :items="categories"
            item-text="nom"
            item-value="ID_KATEGORIA"
            class="m-4"
            v-model="filters.id_kategoria" />


          </v-col>

          <v-col cols="12" md="3">

              <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date2"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="Дата 2"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_furushho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>



            <v-autocomplete class="m-4"
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details

             solo
             prepend-icon="mdi-filter-menu-outline"
             :items="partners"
             item-text="nom"
             item-value="id_partner"
             label="Партнёр"
             v-model="id_partner"
             @change="get_furush_partner"
             @click:clear="get_furushho"/>
          </v-col>
          <v-col cols="12" md="4">





              <v-autocomplete
                clearable
                item-color="primary"
                color="primary"
                hide-no-data
                label="Поставщик"
                hide-details
                multiple
                solo
                prepend-icon="mdi-filter-menu-outline"
                :items="firmaho"
                item-text="nom"
                item-value="id_firma"

                v-model="filters.id_firma" />

                <v-autocomplete class="m-4"
                clearable
                 item-color="primary"
                 color="primary"
                 hide-no-data
                 hide-details

                 solo
                 prepend-icon="mdi-filter-menu-outline"
                 :items="klents"
                 item-text="fio"
                 item-value="id_klent"
                 label="Клиент"
                 v-model="id_klent"
                 @change="get_furush_klent"
                 @click:clear="get_furushho"/>

          </v-col>
          <v-col cols="12" md="2">
              <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="s_smena"
              @keypress.enter="search_smena"
              clearable
              @click:clear="get_furushho"
              label="Смена"/>




          </v-col>
        </v-row>

        <v-data-table
        v-model="selected"
        :headers="headers"
        :items="filteredDesserts"
        :search="searching"
        item-key="id_mol"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
    >
        <template v-slot:header="{ header }">
            <tr class="grey lighten-3">

                <th v-for="header in headers" :key="header.text">
                    <div v-if="filters.hasOwnProperty(header.value)">

                        <v-autocomplete
                            flat
                            hide-details
                            multiple
                            attach
                            chips
                            dense
                            clearable
                            :items="columnValueList(header.value)"
                            v-model="filters[header.value]"
                        >
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index < 5">
                            <span>
                                {{ item }}
                            </span>
                                    </v-chip>
                                    <span v-if="index === 5" class="grey--text caption" >
                                    (+{{ filters[header.value].length - 5 }} others)
                            </span>
                        </template>
                        </v-autocomplete>

                    </div>
                </th>
            </tr>
        </template>

        <template slot="body.append">
            <tr>
                <th ></th>
                <th >Итого</th>
                <th>{{Number( sumFurush('MIK')).toFixed(2) }}</th>
                <th>{{Number( sumFurush('SUMMA_o')).toFixed(2) }}</th>
                <th>{{Number( sumFurush('summa_f')).toFixed(2) }}</th>
                <th>{{Number( sumFurush('SUMMA_o')).toFixed(2) }}</th>
                <th>{{Number( sumFurush('summa_f')).toFixed(2) }}</th>
                <th>{{Number( sumFurush('summa_d')).toFixed(2) }}</th>

            </tr>
        </template>

    </v-data-table>

      </v-container>


      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

  searching: "",
  search: "",
  s_smena: "",
  firmaho: [],
  id_partner: '',
  id_klent: '',

  date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,




    snack: false,
        snackColor: '',
        snackText: '',

    loading: false,
    furushho: [],
    klents: [],
    partners: [],
    smeni: [],
    categories: [],

    selected: [],
			headers: [
				{
					text: 'Код',
					align: 'left',
					value: 'kod',
				},
				{ text: 'Наименование', value: 'nom' },
				{ text: 'Количество', value: 'MIK' },
				{ text: 'Сред.закуп.цена', value: 'n_o' },
                { text: 'Сред.прод.цена', value: 'n_f' },
                { text: 'Сумма прихода', value: 'SUMMA_o' },
                { text: 'Сумма продажа', value: 'summa_f' },
                { text: 'Сумма дохода', value: 'summa_d' },

			],

			filters: {
                nom: [],
                kod: [],
                id_kategoria:[],


			},


            export_furush_fields: [

            {
            'title': 'Код',
            'name': 'kod',
            'width': '20',
            'type': 'Number',
            },
            {
            'title': 'Наименование',
            'name': 'nom',
            'width': '50'

            },

            {
            'title': 'Количество',
            'name': 'MIK',
            'type': 'float',
            'width': '15'
            },

            {
            'title': 'Сред.прод.цена',
            'name': 'n_f',
            'type': 'float',
            'width': '20'
            },

            {
            'title': 'Сумма продажа',
            'name': 'summa_f',
            'type': 'float',
            'width': '20'
            },


        ],




}),

mounted(){
  this.get_klents();
  this.get_furushho();
  this.get_partners();
  this.get_smenaho();
  this.get_firmaho();
  this.get_categories();
},

methods: {
  sumField(key) {
  return  this.filteredProducts.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  sumFurush(key) {
  return  this.filteredDesserts.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  get_klents(){
          this.loading = true;
        axios.get('/api/get_klentho',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.klents = response.data.klents;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  get_categories(){
    this.loading = true;
        axios.get('/api/get_categories',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.categories = response.data.categories;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения категории"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  get_smenaho(){
          this.loading = true;
        axios.get('/api/get_smenaho',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.smeni = response.data.smeni;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  get_partners(){
          this.loading = true;
        axios.get('/api/get_partnerho',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.partners = response.data.partners;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  get_furushho(){
          this.furushho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)
          this.loading = true;
        axios.post('/api/get_sred_furush', { start: this.date1, end: this.date2},
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                            this.loading = false;
                            this.furushho = response.data.sred_furush;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error.response.data.message);
                      //   this.snack = true
                      //   this.snackColor = 'error'
                      //   this.snackText = error.response.data.message;
                      //       setTimeout(() => {
                      //           this.snack = false;
                      //       }, 2000);
                    });
                  },

                  get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  search_smena(){



    this.furushho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)
          this.loading = true;
        axios.post('/api/get_sred_furush_smena', { start: this.date1, end: this.date2, smena: this.s_smena},
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                            this.loading = false;
                            this.furushho = response.data.sred_furush;

                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error.response.data.message);
                      //   this.snack = true
                      //   this.snackColor = 'error'
                      //   this.snackText = error.response.data.message;
                      //       setTimeout(() => {
                      //           this.snack = false;
                      //       }, 2000);
                    });




  },

  get_furush_partner(){

    this.furushho = [];
        //  this.$refs.menu.save(this.date1)
        //  this.$refs.menu2.save(this.date2)
          this.loading = true;
        axios.post('/api/get_furush_partner', { start: this.date1,
                                             end: this.date2,
                                             id_partner: this.id_partner},
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                            this.loading = false;
                            this.furushho = response.data.sred_furush;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                       // console.log(error.response.data.message);
                      //   this.snack = true
                      //   this.snackColor = 'error'
                      //   this.snackText = error.response.data.message;
                      //       setTimeout(() => {
                      //           this.snack = false;
                      //       }, 2000);
                    });

  },

  get_furush_klent(){

    this.furushho = [];
        //  this.$refs.menu.save(this.date1)
        //  this.$refs.menu2.save(this.date2)
          this.loading = true;
        axios.post('/api/get_furush_klent', { start: this.date1,
                                             end: this.date2,
                                             id_klent: this.id_klent},
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                            this.loading = false;
                            this.furushho = response.data.sred_furush;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                      //  console.log(error.response.data.message);
                        // this.snack = true
                        // this.snackColor = 'error'
                        // this.snackText = error.response.data.message;
                        //     setTimeout(() => {
                        //         this.snack = false;
                        //     }, 2000);
                    });

  },


columnValueList(val) {
    return this.furushho.map((d) => d[val]);
},

},

computed: {

	filteredDesserts() {
				return this.furushho.filter((d) => {
					return Object.keys(this.filters).every((f) => {
						return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
					});
				});
			},

}

}
</script>

<style  scoped>

</style>



